<button type="button" [id]="question.addButtonId" *ngIf="question.canAddPanel" [class]="question.getAddButtonCss()" (click)="addPanelClick()">
<span [class]="question.cssClasses.buttonAddText"><sv-ng-string [model]="question.locAddPanelText"></sv-ng-string></span>
</button>